<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box zero_balance modal_cont" id="">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_zero_balance_zero_game_balance }}</h1>
        <img :src="getTranslations.home_modals_zero_balance_image || 'static/images/popups/zero_ballance.png'" class="zero_bal_img" alt="">
        <p>{{ getTranslations.home_modals_zero_balance_unlock_more_games_msg }}</p>
        <button type="" v-if="!hideStore" @click.prevent="toBundlesPage">
          {{ getTranslations.home_modals_zero_balance_unlock_games }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'zero-balance',
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    toBundlesPage() {
      this.storeModalForHomePage(null);
      this.$router.push('/home/store');
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ZeroBalance.vue